/**
 * A count with its noun: "1 study", "14 studies", "2 groups". The plural is
 * the singular plus s unless given. The collection page used to spell this
 * out at every count, and the copies drifted: the toolbar and the Delete
 * confirm came to count the same selection differently with nothing to flag
 * it.
 */
export function nouns(n: number, one: string, many = one + 's'): string {
  return `${n} ${n === 1 ? one : many}`;
}
